import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { PdaPagamento } from '../../../models/pda-pagamenti';
import { DialogService } from 'src/app/core/components/dialog/dialog.service';
import { PagamentiDetailComponent } from '../../pagamenti-detail/pagamenti-detail/pagamenti-detail.component';
import { PdaDownloadAvvisoRequest } from '../../../models/pda-download-avviso-request';
import { PdaDownloadRicevutaRequest } from '../../../models/pda-download-ricevuta-request';
import { Pagination } from 'src/app/common/models/pagination';

@Component({
  selector: 'app-pagamenti-list',
  templateUrl: './pagamenti-list.component.html',
  styleUrls: ['./pagamenti-list.component.css']
})
export class PagamentiListComponent implements OnInit, OnChanges {

  @Input() payments: PdaPagamento[] = [];
  currentPayments: PdaPagamento[] = [];
  @Input() hasSearched: boolean;
  @Output() downloadAvvisoEvent: EventEmitter<PdaDownloadAvvisoRequest> = new EventEmitter<PdaDownloadAvvisoRequest>();
  @Output() downloadRicevutaEvent: EventEmitter<PdaDownloadRicevutaRequest> = new EventEmitter<PdaDownloadRicevutaRequest>();
  @Output() refreshEvent: EventEmitter<void> = new EventEmitter<void>();
  currentPage: number = 0;
  itemsPerPage: number = 10;
  resetCurrentPage: boolean = false;

  constructor(private dialog: DialogService){

  }

  ngOnInit(): void {
    if(this.payments) this.setPaymentsToShow();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.payments != undefined && !changes.payments.firstChange){
      this.resetCurrentPage = true;
      this.currentPage = 0;
      // this.itemsPerPage = 10;
      this.setPaymentsToShow();
    }
  }


  getPaymentStatusIcon(stato: string){
    stato = stato.toLocaleUpperCase();
    switch(stato){
      case 'GENERATA':
        return "glyphicon glyphicon-send";
      case 'DISPONIBILE':
        return "glyphicon glyphicon-ok-sign status-green";
      case 'USATO':
        return "glyphicon glyphicon-ok";
      case 'USATO':
        return "glyphicon glyphicon-tasks status-green";
      case 'RIMBORSATO':
        return "glyphicon glyphicon-tasks status-red";
      case 'REVOCATO':
      case 'ERRORE':
        return 'glyphicon glyphicon-remove-sign status-red';
    }
  }

  getPaymentStatusTitle(stato: string){
    stato = stato.toLocaleUpperCase();
    switch(stato){
      case 'GENERATA':
        return "L'avviso di pagamento è stato generato";
      case 'DISPONIBILE':
        return "La ricevuta di pagamento è disponibile";
      case 'USATO':
        return "Il pagamento è stato utilizzato";
      case 'ATTESA':
        return "Il pagamento è in attesa";
      case 'RIMBORSATO':
        return "Il pagamento è stato rimborsato";
      case 'REVOCATO':
      case 'ERRORE':
        return 'Il pagamento è fallito';
    }
  }

  isError(stato){
    return stato.toLocaleUpperCase() == 'ERRORE';
  }

  hasRicevuta(pagamento: PdaPagamento){
    return !!pagamento.dataRicevuta;
  }

  downloadAvviso(numeroAvviso: string){
    let req: PdaDownloadAvvisoRequest = new PdaDownloadAvvisoRequest();
    req.numeroAvviso = numeroAvviso;
    this.downloadAvvisoEvent.emit(req);
  }

  downloadRicevuta(str: string, bool: boolean, tipo: string){
    let req: PdaDownloadRicevutaRequest = new PdaDownloadRicevutaRequest();
    if(tipo == "XML"){
      req.codiceCRS = str;
      req.copiaOriginale = bool;
      req.tipo = tipo;
    } else if(tipo == "PDF"){
      req.idPagamento = str;
      req.bollo = bool;
      req.tipo = tipo;
    }
    this.downloadRicevutaEvent.emit(req);
  }

  onOpenDetail(pagamento: PdaPagamento){
    const ref = this.dialog.open(PagamentiDetailComponent, {
      data: {
        style: {
          width: '50%',
          overflow: false
        },
        pagamento: pagamento,
        title: 'Informazioni del Pagamento Telematico',
      }
    });
  }

  onRefresh(event: Pagination){
    this.currentPage = event.getCurrentPage();
    this.itemsPerPage = event.getItemsPerPage();

    this.setPaymentsToShow();
    this.resetCurrentPage = false;
  }

  setPaymentsToShow(){
    this.currentPayments = this.payments.slice(this.currentPage*this.itemsPerPage, (this.currentPage+1)*this.itemsPerPage);
  }

}
